import axios from "axios";
import api from "../api";

export let apiToken = JSON.parse(localStorage.getItem("user_profile"));

const authApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export const authApi2 = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + apiToken?.accessToken,
  },
});

const AuthModule = () => {
  return {
    Login: function (data) {
      return authApi.post("Auth/login", data);
    },

    SetupAuthenticator: function (data) {
      return authApi.post("Auth/authenticator/setup", data);
    },

    CompleteTwoFactorLogin: function (data) {
      return authApi.post("Auth/login-2fa", data);
    },

    RefreshToken: function (data) {
      return authApi.post("Auth/refresh", data);
    },

    Logout: function (data, accessToken) {
      return authApi.post("Auth/logout", data, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
    },

    ResetPassword: function (data) {
      return authApi.post("SecurityService/reset-password", data);
    },

    CurrentUser: function (data) {
      return authApi2.get("Auth/sessiondetails", data);
    },

    // https://onboarding-dev.flexmonie.com./v1/api/Agent/account-details/777

    AccountDetails: function (data) {
      return api.get(`Agent/account-details/${data}`);
    },

    // *************************************************

    ServiceToday: function (data) {
      return api.get(`wallet/Wallet/report/service/today`);
    },

    ServiceWeek: function (data) {
      return api.get("wallet/Wallet/report/service/this_week");
    },

    AgentDetails: function (data) {
      const { page, limit } = data;
      return api.get(
        `/transactions/report/superdealer/performance/top-resselers?customer_id=501&service_codes=100,101,102,103,106,105&per_page=${limit}&page=${page}`
      );
    },

    // Customer/states
    CustomerStates: function (data) {
      return api.get("customer/states");
    },

    // Customer/lga/1
    CustomerLga: function (data) {
      return api.get(`customer/lga/${data}`);
    },

    // Superdealer/wallet-setup
    SuperdealerWalletSetup: function (data) {
      return api.post("superdealer/wallet-setup", data);
    },

    // // SecurityService/create-pin
    // CreatePin: function (data) {
    //   return authApi.post("SecurityService/create-pin", data);
    // }
  };
};

export const AuthService = {
  auth: AuthModule,
};
